import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Alert } from "@mui/material";
import apiClient from "./utils/apiClient";

const ForgotPasswordDialog = ({ open, onClose }) => {
  const [email, setEmail] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false); // Track if the form is submitted

  const handleForgotPassword = async () => {
    try {
      setErrorMessage("");
      setSuccessMessage("");
      await apiClient.post("/forgot-password", { email }); // Ensure the payload matches the backend model
      setSuccessMessage("Password reset email sent successfully.");
      setIsSubmitted(true); // Mark the form as submitted
    } catch (error) {
      setErrorMessage("Failed to send password reset email. Please try again.");
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Forgot Password</DialogTitle>
      <DialogContent>
        {errorMessage && <Alert severity="error">{errorMessage}</Alert>}
        {successMessage && <Alert severity="success">{successMessage}</Alert>}
        {!isSubmitted && ( // Hide form fields after submission
          <TextField
            label="Email Address"
            type="email"
            fullWidth
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        )}
      </DialogContent>
      <DialogActions>
        {!isSubmitted && ( // Hide buttons after submission
          <>
            <Button onClick={onClose}>Cancel</Button>
            <Button onClick={handleForgotPassword} color="primary">
              Submit
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ForgotPasswordDialog;
